export const checkboxTheme = {
    width: '0.875rem',
    height: '0.875rem',
    focus: {
        boxShadow: {
            sizes: '0 0 0 3px',
            color: (props) => props.theme.palette.primary,
        },
    },
    border: {
        radius: (props) => props.theme.radius.md,
        color: {
            inactive: (props) => props.theme.palette.secondaryAlt,
            checked: (props) => props.theme.palette.primary,
            disabled: (props) => props.theme.palette.secondary,
            error: (props) => props.theme.palette.error,
            hover: (props) => props.theme.palette.primary,
        },
    },
    background: {
        color: {
            inactive: (props) => props.theme.palette.surfaceAlt,
            checked: (props) => props.theme.palette.primary,
            disabled: (props) => props.theme.palette.secondary,
            error: (props) => props.theme.palette.error,
        },
    },
    icon: {
        padding: '2px 1px',
        color: {
            inactive: (props) => props.theme.palette.surfaceAlt,
            checked: (props) => props.theme.palette.surfaceAlt,
            disabled: (props) => props.theme.palette.secondaryAlt,
            error: (props) => props.theme.palette.surfaceAlt,
        },
    },
};
